import NewsletterForm from './NewsletterForm'
import React from 'react'
import SocialNetworks from '../SocialNetworks/SocialNetworks'
import styled from 'styled-components'

const NewsletterWrapper = styled.div`
  background-color: #1a2846;
`

const CenteredNewsletter = styled.div`
  align-items: stretch;
  flex-direction: column;
  padding: 35px 30px;
  justify-content: space-between;

  @media (min-width: 992px) {
    align-items: stretch;
    flex-direction: row;
    padding: 40px 0px;
  }
`

const Newsletter = () => {
  return (
    <NewsletterWrapper>
      <CenteredNewsletter className="centered-container centered flex branco">
        <NewsletterForm />
        <SocialNetworks />
      </CenteredNewsletter>
    </NewsletterWrapper>
  )
}

export default Newsletter
